import baseApi from 'shared/api/baseApi';

import type {
  AgentTestScenario,
  DuplicateScenarioBody,
  ScenarioBody,
  ScenariosListParams,
  ScenariosListResponse,
} from '../model/scenario';

const scenariosApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getScenarios: build.query<ScenariosListResponse, ScenariosListParams>({
      query: ({ projectId, scope, tag, enabled, page, limit }) => ({
        url: '/admin/agentEvals/scenarios',
        method: 'GET',
        params: {
          projectId,
          page,
          limit,
          ...(scope ? { scope } : {}),
          ...(tag ? { tag } : {}),
          ...(enabled !== undefined ? { enabled } : {}),
        },
      }),
      providesTags: [{ type: 'AgentTestScenarios', id: 'LIST' }],
    }),
    createScenario: build.mutation<AgentTestScenario, ScenarioBody>({
      query: (body) => ({
        url: '/admin/agentEvals/scenarios',
        method: 'POST',
        body,
      }),
      invalidatesTags: [{ type: 'AgentTestScenarios', id: 'LIST' }],
    }),
    updateScenario: build.mutation<AgentTestScenario, { scenarioId: number; body: Partial<ScenarioBody> }>({
      query: ({ scenarioId, body }) => ({
        url: `/admin/agentEvals/scenarios/${scenarioId}`,
        method: 'PATCH',
        body,
      }),
      invalidatesTags: [{ type: 'AgentTestScenarios', id: 'LIST' }],
    }),
    deleteScenario: build.mutation<AgentTestScenario, number>({
      query: (scenarioId) => ({
        url: `/admin/agentEvals/scenarios/${scenarioId}`,
        method: 'DELETE',
      }),
      invalidatesTags: [{ type: 'AgentTestScenarios', id: 'LIST' }],
    }),
    duplicateScenario: build.mutation<AgentTestScenario, { scenarioId: number; body: DuplicateScenarioBody }>({
      query: ({ scenarioId, body }) => ({
        url: `/admin/agentEvals/scenarios/${scenarioId}/duplicate`,
        method: 'POST',
        body,
      }),
      invalidatesTags: [{ type: 'AgentTestScenarios', id: 'LIST' }],
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetScenariosQuery,
  useCreateScenarioMutation,
  useUpdateScenarioMutation,
  useDeleteScenarioMutation,
  useDuplicateScenarioMutation,
} = scenariosApi;

export default scenariosApi;
